export async function DatconsumoCreate(
  datconsResp,
  datconsFecha,
  datconsTipo,
  datconsSustRep,
  datconsObs,
  tratamientoId,
  pacienteId
) {
  const formData = {
    title: `us-${pacienteId}-tr-${tratamientoId}-datcons-${datconsFecha}`,
    slug: `us-${pacienteId}-tr-${tratamientoId}-datcons-${datconsFecha}`,
    status: "publish",
    tratamiento: tratamientoId,
    paciente: pacienteId,
    meta: {
      datconsResp: datconsResp,
      metaFecha: datconsFecha,
      datconsTipo: datconsTipo,
      datconsSustRep: datconsSustRep,
      datconsObs: datconsObs,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/datconsumo",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
